import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ld-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.css']
})
export class MessageListComponent implements OnInit {
  @Input() messages = [];

  constructor() { }

  ngOnInit() {
     this.messages.sort(this.compareDate);
  }

  public compareDate(a, b): number {
    const dateA: any = new Date(a.dateCreated);
    const dateB: any = new Date(b.dateCreated);
    let comparison = 0;
    if (dateA > dateB) {
      comparison = 1;
    } else if (dateA < dateB) {
      comparison = -1;
    }
    return comparison * -1;
  }
}
